// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import cprEntity from './entities/cpr.json';
import cprMenu from '../pages/cpr/menu.json';
import cprFullForm from '../pages/cpr/forms/full.json';
import cprContextForm from '../pages/cpr/forms/context.json';
import cprMiniForm from '../pages/cpr/forms/mini.json';
import cprLookupForm from '../pages/cpr/forms/lookup.json';
import cprTableView from '../pages/cpr/views/table.json';
import cprStagesView from '../pages/cpr/views/stages.json';
import cprCardsView from '../pages/cpr/views/cards.json';
import cprInlineView from '../pages/cpr/views/inline.json';
import cprBacklogView from '../pages/cpr/views/backlog.json';
import cprSplitView from '../pages/cpr/views/split.json';
import cprCalendarView from '../pages/cpr/views/calendar.json';
import cprDashboardView from '../pages/cpr/views/dashboard.json';

/** Тип запису «Пропозиція» зі сторінками пакета: меню, форми та подання з pages/cpr/. */
export const cprDefinition: IRecordTypeDefinition = {
  ...cprEntity,
  views: assembleViewSet({
      table: cprTableView,
      stages: cprStagesView,
      cards: cprCardsView,
      inline: cprInlineView,
      backlog: cprBacklogView,
      split: cprSplitView,
      calendar: cprCalendarView,
      dashboard: cprDashboardView,
  }),
  form: cprFullForm,
  forms: { full: cprFullForm, context: cprContextForm, mini: cprMiniForm, lookup: cprLookupForm },
  menu: cprMenu,
} as IRecordTypeDefinition;
